import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-fuwuguanli",
  "use": "icon-icon-fuwuguanli-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-fuwuguanli\"><path d=\"M512 486.208a467.648 467.648 0 0 0-320-126.208v391.104c123.712 0 236.096 48 320 126.208a469.312 469.312 0 0 1 320-126.208V360c-123.712 0-236.096 48-320 126.208z m0-126.208c59.008 0 106.688-47.616 106.688-106.688 0-59.008-47.68-106.624-106.688-106.624s-106.688 47.616-106.688 106.624c0 59.072 47.68 106.688 106.688 106.688z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-fuwuguanli.svg
// module id = hYqt
// module chunks = 3